import { Box, CircularProgress, styled } from '@mui/material';

import type { Drug } from '@/api/domains/drugs.types';
import { ModalBodyContent } from '@/components/Modal';

import type { NomenclatureModalVariant } from '../types';
import { InstructionForPharmacistForm } from './InstructionForPharmacistForm';
import { useInstructionForPharmacist } from './useInstructionForPharmacist';

const BoxContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
});

export type InstructionForPharmacistTabProps = {
  onClose: VoidFunction;
  drug: Drug;
  variant: NomenclatureModalVariant | null;
};

const LoadingIndicator = () => (
  <BoxContainer>
    <CircularProgress color={'secondary'} />
  </BoxContainer>
);

export const InstructionForPharmacistTab = (props: InstructionForPharmacistTabProps) => {
  const { drug } = props;

  const { isInitialLoading, data: instructionForPharmacist } = useInstructionForPharmacist(drug.id);

  if (isInitialLoading) {
    return (
      <ModalBodyContent>
        <LoadingIndicator />
      </ModalBodyContent>
    );
  }

  return (
    <InstructionForPharmacistForm
      {...props}
      instructionForPharmacist={{
        ...instructionForPharmacist,
        record_status_id: drug.record_status_id,
      }}
    />
  );
};
